import styled from '@emotion/styled';

const StyledLocalization = styled.div`
  color: pink;
`;

export function Localization() {
  return (
    <StyledLocalization>
      <h1>Welcome to Localization!</h1>
    </StyledLocalization>
  );
}

export default Localization;
